module.exports = __webpack_public_path__ + "static/media/MASPHLIQUIDO.b43863f7.png";